import * as types from '../actions/action-types';

export function getCategoriesListSuccess(categoryListData) {
  return {
    type: types.GET_CATEGORIESLIST_SUCCESS,
    categoryListData
  };
}

export function propsRecievedCategoryList(propsRecieved) {
  return {
    type: types.PROPS_RECIEVED_CATEGORYLIST,
    propsRecieved
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/base-actions.js
 **/